import { Avatar } from '../../../layout/Avatar.jsx';
import { Pill } from '../../../layout/Pill.jsx';
import { formatDateTime } from '../../../shared/format.js';

function resultPill(r) {
  if (r === 'allowed') return <Pill variant="success">مقبول</Pill>;
  if (r === 'blocked') return <Pill variant="danger">مرفوض</Pill>;
  if (r === 'overstayed') return <Pill variant="warning">تجاوز</Pill>;
  if (r === 'manual_override') return <Pill variant="orange">تجاوز يدوي</Pill>;
  // اشتراك شهري منتهٍ عند بوابة الدخول، وفواتير غير مسدَّدة عند الخروج —
  // كانتا تظهران «—» فلا يعرف الموظف سبب إغلاق الباب.
  if (r === 'subscription_expired') return <Pill variant="danger">اشتراك منتهٍ</Pill>;
  if (r === 'blocked_pending') return <Pill variant="orange">فواتير معلقة</Pill>;
  if (r === 'no_session') return <Pill variant="muted">لا جلسة</Pill>;
  return <Pill variant="muted">—</Pill>;
}

function relTime(at) {
  if (!at) return '';
  const diff = Date.now() - new Date(at).getTime();
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s} ثانية`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} دقيقة`;
  const h = Math.floor(m / 60);
  return `${h} ساعة`;
}

export function EventRow({ event, isFirst }) {
  const at = event.createdAt || event.at;
  // الخادم يُحمّل الطفل في `childId` عبر REST ويُرسله في `child` عبر البثّ.
  const child = event.child || (typeof event.childId === 'object' ? event.childId : null) || {};
  return (
    <tr
      className="border-b border-line"
      style={isFirst ? { animation: 'gateFadeIn .5s ease' } : undefined}
    >
      <td className="p-2 text-[12px] text-ink-3" title={at ? formatDateTime(at) : ''}>
        {relTime(at)}
      </td>
      <td className="p-2 text-[12px]">{event.gate?.name || event.gateName || '—'}</td>
      <td className="p-2 font-mono text-[12px]" dir="ltr">{event.cardUid || '—'}</td>
      <td className="p-2">
        {child.name ? (
          <div className="flex items-center gap-2">
            <Avatar src={child.photoUrl} name={child.name} id={child._id || child.id} size="sm" />
            <span className="text-[12.5px]">{child.name}</span>
          </div>
        ) : (
          <span className="text-ink-3 text-[12px]">—</span>
        )}
      </td>
      <td className="p-2">
        <div className="flex items-center gap-1">
          {resultPill(event.result)}
          {event.subscriptionCovered ? (
            <Pill variant="info" className="!px-1.5 !py-0 !text-[10px]">اشتراك</Pill>
          ) : null}
        </div>
      </td>
      <td className="p-2 text-[11.5px] text-ink-2">{event.reason || ''}</td>
    </tr>
  );
}
